import type { Table as TanstackTable } from '@tanstack/react-table';
import { PaginationNavigation } from '@/shared/components/pagination';

export const DataTablePagination = <T extends object>({ table }: { table: TanstackTable<T> }) => {
  const pageIndex = table.getState().pagination.pageIndex;
  const pageSize = table.getState().pagination.pageSize;
  const totalPages = table.getPageCount();
  const totalItems = table.getRowCount();

  return (
    <PaginationNavigation
      currentPage={pageIndex + 1} // TanStack uses 0-based indexing, our component uses 1-based
      totalPages={totalPages}
      pageSize={pageSize}
      totalItems={totalItems}
      onPageChange={(page) => table.setPageIndex(page - 1)} // Convert back to 0-based indexing
      onPageSizeChange={(newPageSize) => table.setPageSize(newPageSize)}
      showPageSizeSelector={true}
      pageSizeOptions={[10, 20, 30, 40, 50]}
    />
  );
};
